import { Component, OnInit, ViewChild, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SharedDataService } from '../../../../services/sharedData/shared-data.service';
import { Filters, FiltersStorage, Level, PersonalTrainer, UserComplete } from '../../../../api/interfaces/user';
import { MobileDetectorService } from '../../../../services/mobileDetector/mobile-detector.service';
import {MatAccordion} from '@angular/material/expansion';
import { TrainingService } from 'src/app/api/services/training/training.service';
import { RegisterService } from 'src/app/api/services/register/register.service';
import { Status, TrainingDays } from 'src/app/api/interfaces/register';


@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})
export class FiltersComponent implements OnInit {

  @ViewChild(MatAccordion) accordion: MatAccordion;
  @ViewChild('trainerSelect') trainerSelect;
  @Output() filtersChangeEvent = new EventEmitter<Filters>();
  @Output() filtersFromSessionStorageEvent = new EventEmitter<Filters>();

  isMobile: boolean = false;
  trainer: PersonalTrainer = null;
  contador: number;

  filtersForm = new FormGroup({
    nombreApellido: new FormControl(),
    status: new FormControl(),
    type: new FormControl(),
    level: new FormControl(),
    trainer: new FormControl(),
    leido: new FormControl()
  });

  allStatus: Status[] = [];
  types: any;
  levels: any;
  trainers: any;
  modes: any;
  trainingDays: TrainingDays[] = [];
  disabled: boolean = true;
  statusClass = "inputsFilter";

  leidoOpciones = [
    {
      nombre: "Gestionado",
      value: true
    },
    {
      nombre: "Sin gestionar",
      value: false
    }
  ];

  constructor(
    private sharedData: SharedDataService,
    private mobileDetectorService: MobileDetectorService,
    private trainingService: TrainingService,
    private registerService: RegisterService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.isMobile = this.mobileDetectorService.isMobile();
    //se anidaron las llamadas a api para tener todos los datos cargados al momento de leer los filtros desde localstorage
    this.loadLevels();
    this.cdr.detectChanges();
    // this.setFiltersFromSessionlStorage();
    this.filtersForm.statusChanges
    .subscribe(val => {
      const { nombreApellido, status, type, level, trainer, leido } = this.filtersForm.getRawValue();
      this.contador = 0;
      if(status) {
        this.contador++;
        this.statusClass = "inputsFilterWithContent"
      } else {
        this.statusClass = "inputsFilter"
      }
      if(type) {
        this.contador++;
      }
      if(level) {
        this.contador++;
      }
      if(trainer) {
        this.contador++;
      }
      if(leido != null) {
        this.contador++;
      }
      if(this.contador > 0) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    });
  }

  setFiltersFromSessionlStorage() {
    const filters: FiltersStorage = JSON.parse(sessionStorage.getItem('filters'));
    const fromDay: boolean = JSON.parse(sessionStorage.getItem('fromDay'));
    if(filters) {
      this.filtersForm.patchValue({nombreApellido: filters.nombreApellido});
      this.filtersForm.patchValue({trainer: filters.trainer});
      this.filtersForm.patchValue({status: filters.status});
      this.filtersForm.patchValue({leido: filters.leido});
      this.filtersForm.patchValue({level: filters.level});
      this.filtersForm.patchValue({type: filters.type});
      this.filtersFromSessionStorageEvent.emit(this.filtersForm.value);
    }
    if(!filters && fromDay) {
      this.filtersFromSessionStorageEvent.emit(this.filtersForm.value);
    }
  }

  loadStatus() {
    this.trainingService.getStatus().subscribe(response => {
      this.allStatus = response;
      this.setFiltersFromSessionlStorage();
    },
    error => {
      console.error(error);
    })

  }

  loadLevels() {
    this.trainingService.getLevels().subscribe( response=> {
      this.levels = response;
      this.loadTrainers();
    },
    error => {
      console.error(error);
    });
  }

  loadTrainers() {
    this.trainingService.getTrainers().subscribe( response=> {
      this.trainers = response;
      this.getTrainingDays();
      this.loadStatus();
    },
    error => {
      console.error(error);
    });
  }

  getTrainingDays () {
    this.registerService.getTrainingDays()
    .subscribe(response => {
      this.trainingDays = response;
    },
      error => {
        console.error(error);
      });
  }

  onSubmit() {
    this.filtersChangeEvent.emit(this.filtersForm.value);
  }

  clearAll() {
    this.filtersForm.patchValue({status: null});
    this.filtersForm.patchValue({type: null});
    this.filtersForm.patchValue({level: null});
    this.filtersForm.patchValue({trainer: null});
    this.filtersForm.patchValue({leido: null});
    this.filtersChangeEvent.emit(this.filtersForm.value);
  }

  clear(target: string) {
    switch (target) {
      case 'nombreApellido':
      this.filtersForm.patchValue({nombreApellido: null});
      break;
      
      
      case 'status':
      this.filtersForm.patchValue({status: null});
      break;
      
      case 'type':
      this.filtersForm.patchValue({type: null});
      break;
      
      case 'level':
      this.filtersForm.patchValue({level: null});
      break;
      
      case 'trainer':
      this.filtersForm.patchValue({trainer: null});
      break;

      case 'leido':
      this.filtersForm.patchValue({leido: null});
      break;
    }
    this.filtersChangeEvent.emit(this.filtersForm.value);
  }

  // saveTrainingDay(option: TrainingDays) {
  //   this.filtersForm.patchValue({type: option});
  // }

}

